///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportEmployee = Meevo.Plugins.Reports.IReportEmployee;

    export class TextelEmployeesCollection extends SmartMoverApiCollection<IReportEmployee> implements IApiCollection<IReportEmployee> {

        protected get url() {
            return 'Report/Employee';
        }

        constructor(connectedModel: ModelValueType[], items: IReportEmployee[] = [], options: ICollectionOptions<IReportEmployee> = {}) {
            super(connectedModel, items, options);
        }
    }

}
